import React from "react";
import { Card, CardTitle, CardBody, CardImg } from "reactstrap";
import noPhotoProvided from "@/assets/img/noPhotoProvided.png";

export default function Photo({ src, name, ...rest }) {
  return (
    <Card {...rest}>
      <CardBody>
        <CardTitle style={{ marginBottom: 0 }}>{name}</CardTitle>
      </CardBody>
      <CardImg bottom width="100%" src={src || noPhotoProvided} alt={name} />
    </Card>
  );
}
